(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
(()=>{const headers=document.querySelectorAll('[data-znav]');headers.forEach(header=>{const toggles=header.querySelectorAll('[data-znav-toggle]');const closers=header.querySelectorAll('[data-znav-close]');const set=open=>{header.classList.toggle('is-open',open);toggles.forEach(button=>button.setAttribute('aria-expanded',String(open)));document.documentElement.style.overflow=open?'hidden':''};toggles.forEach(button=>button.addEventListener('click',()=>set(!header.classList.contains('is-open'))));closers.forEach(button=>button.addEventListener('click',()=>set(false)));header.addEventListener('keydown',event=>{if(event.key==='Escape')set(false)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrinest-alpino-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nlp-root]').forEach((root) => {
    const media = [...root.querySelectorAll('[data-nlp-media]')];
    const thumbs = [...root.querySelectorAll('[data-nlp-thumb]')];
    let active = 0;
    const showMedia = (index) => {
      if (!media.length) return;
      active = (index + media.length) % media.length;
      media.forEach((item, i) => item.classList.toggle('is-active', i === active));
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === active));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.nlpThumb))));
    root.querySelector('[data-nlp-prev]')?.addEventListener('click', () => showMedia(active - 1));
    root.querySelector('[data-nlp-next]')?.addEventListener('click', () => showMedia(active + 1));

    const form = root.querySelector('.nlp__form');
    const payable = root.querySelector('[data-nlp-payable]');
    const quantity = form?.querySelector('[name="quantity"]');
    const syncPayable = () => {
      if (!payable) return;
      const count = Math.max(1, Number(quantity?.value) || 1);
      const total = Math.max(0, Number(payable.dataset.unitPrice) * count - 50000);
      payable.querySelector('[data-nlp-payable-price]').textContent = 'Rs. ' + (total / 100).toLocaleString('en-PK', {minimumFractionDigits: 0, maximumFractionDigits: 2});
      payable.querySelector('[data-nlp-coupon-note]').textContent = count > 1 ? 'For ' + count + ' packs · Rs 500 off total' : 'One voucher per order';
      payable.hidden = Date.now() > Date.parse('2026-11-12T23:59:00+05:00');
    };
    const couponButton = root.querySelector('[data-nlp-copy-coupon]');
    couponButton?.addEventListener('click', async () => {
      const label = couponButton.querySelector('[data-nlp-copy-label]');
      try {
        await navigator.clipboard.writeText(couponButton.dataset.code);
        label.textContent = 'Copied ✓';
        couponButton.classList.add('is-copied');
        window.setTimeout(() => { label.textContent = 'Copy code ⧉'; couponButton.classList.remove('is-copied'); }, 2500);
      } catch (error) { label.textContent = 'Use ' + couponButton.dataset.code; }
    });
    quantity?.addEventListener('input', syncPayable);
    quantity?.addEventListener('change', syncPayable);
    const variants = [...root.querySelectorAll('[data-nlp-variant-option]')];
    const price = root.querySelector('[data-nlp-price] strong');
    const comparePrice = root.querySelector('[data-nlp-compare]');
    const saving = root.querySelector('[data-nlp-saving]');
    const stickyPrice = root.querySelector('[data-nlp-sticky-price]');
    const atc = root.querySelector('[data-nlp-atc]');
    const stickyAtc = root.querySelector('[data-nlp-submit-sticky]');
    const syncAvailability = (option) => {
      if (!option) return;
      const inStock = option.dataset.inStock === 'true';
      if (atc) {
        atc.disabled = !inStock;
        const label = atc.querySelector('span');
        if (label) label.textContent = inStock ? 'Add to cart' : 'Sold out';
      }
      if (stickyAtc) {
        stickyAtc.disabled = !inStock;
        stickyAtc.textContent = inStock ? 'Add to cart' : 'Sold out';
      }
    };
    const syncVariant = (option) => {
      if (!option) return;
      if (price) price.textContent = option.dataset.price;
      if (payable) payable.dataset.unitPrice = option.dataset.priceAmount;
      syncPayable();
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      const hasCompare = option.dataset.hasCompare === 'true';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.compare;
        comparePrice.hidden = !hasCompare;
      }
      if (saving) {
        saving.textContent = `Save ${option.dataset.saving}`;
        saving.hidden = !hasCompare;
      }
      syncAvailability(option);
    };
    variants.forEach((option) => option.addEventListener('change', () => syncVariant(option)));
    syncVariant(variants.find((option) => option.checked));
    root.querySelectorAll('[data-nlp-scroll-buy]').forEach((button) => button.addEventListener('click', () => {
      root.querySelector('.nlp__buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    root.querySelector('[data-nlp-submit-sticky]')?.addEventListener('click', () => form?.requestSubmit());

    const sticky = root.querySelector('[data-nlp-sticky]');
    const buybox = root.querySelector('.nlp__buybox');
    if (sticky && buybox && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.1 }).observe(buybox);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["springoo-alpino-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nlp-root]').forEach((root) => {
    const media = [...root.querySelectorAll('[data-nlp-media]')];
    const thumbs = [...root.querySelectorAll('[data-nlp-thumb]')];
    let active = 0;
    const showMedia = (index) => {
      if (!media.length) return;
      active = (index + media.length) % media.length;
      media.forEach((item, i) => item.classList.toggle('is-active', i === active));
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === active));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.nlpThumb))));
    root.querySelector('[data-nlp-prev]')?.addEventListener('click', () => showMedia(active - 1));
    root.querySelector('[data-nlp-next]')?.addEventListener('click', () => showMedia(active + 1));

    const form = root.querySelector('.nlp__form');
    const variants = [...root.querySelectorAll('[data-nlp-variant-option]')];
    const price = root.querySelector('[data-nlp-price] strong');
    const comparePrice = root.querySelector('[data-nlp-compare]');
    const saving = root.querySelector('[data-nlp-saving]');
    const stickyPrice = root.querySelector('[data-nlp-sticky-price]');
    const atc = root.querySelector('[data-nlp-atc]');
    const stickyAtc = root.querySelector('[data-nlp-submit-sticky]');
    const syncAvailability = (option) => {
      if (!option) return;
      const inStock = option.dataset.inStock === 'true';
      if (atc) {
        atc.disabled = !inStock;
        const label = atc.querySelector('span');
        if (label) label.textContent = inStock ? 'Add to cart' : 'Sold out';
      }
      if (stickyAtc) {
        stickyAtc.disabled = !inStock;
        stickyAtc.textContent = inStock ? 'Add to cart' : 'Sold out';
      }
    };
    const syncVariant = (option) => {
      if (!option) return;
      if (price) price.textContent = option.dataset.price;
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      const hasCompare = option.dataset.hasCompare === 'true';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.compare;
        comparePrice.hidden = !hasCompare;
      }
      if (saving) {
        saving.textContent = `Save ${option.dataset.saving}`;
        saving.hidden = !hasCompare;
      }
      syncAvailability(option);
    };
    variants.forEach((option) => option.addEventListener('change', () => syncVariant(option)));
    syncVariant(variants.find((option) => option.checked));
    root.querySelectorAll('[data-nlp-scroll-buy]').forEach((button) => button.addEventListener('click', () => {
      root.querySelector('.nlp__buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    root.querySelector('[data-nlp-submit-sticky]')?.addEventListener('click', () => form?.requestSubmit());

    const sticky = root.querySelector('[data-nlp-sticky]');
    const buybox = root.querySelector('.nlp__buybox');
    if (sticky && buybox && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.1 }).observe(buybox);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
